import { createSelector } from 'reselect';
import { initialState } from './reducer';
/**
 * Direct selector to the languageToggle state domain
 */
var selectLanguage = function (state) { return state.language || initialState; };
/**
 * Select the language locale
 */
var makeSelectLocale = function () {
    return createSelector(selectLanguage, function (languageState) { return languageState.locale; });
};
export { selectLanguage, makeSelectLocale };
